import React, { useState } from 'react';

import { buttonVariants } from '@clatter/ui';
import { NgButton } from '../../UI';
import { FolderManagerAddFolderForm } from './FolderManagerAddFolderForm';

export const FolderManagerDialogAddForm: React.FC<any> = ({
  onAction,
  isLoading,
  submitLabel = 'Add Group',
  title = 'Add New Group',
}) => {
  const [name, setName] = useState('');

  return (
    <>
      <div className="content">
        <h3>{title}</h3>

        <div className="add-form">
          <FolderManagerAddFolderForm
            editedItem={{ id: null, name: '' }}
            errors={{}}
            onChange={setName}
            isLoading={isLoading}
          />
        </div>
      </div>

      <div className="footer">
        <div className="buttons">
          <NgButton
            testId="folder-manager-move-dialog-cancel-button"
            onClick={() => onAction('cancel')}
            variant={buttonVariants.clear}
            type="button"
          >
            Cancel
          </NgButton>

          <NgButton
            testId="folder-manager-move-dialog-submit-button"
            onClick={() => onAction('submit', { name: name })}
            disabled={isLoading}
            variant={buttonVariants.primary}
          >
            {submitLabel}
          </NgButton>
        </div>
      </div>
    </>
  );
};
